<template>
    <div id="modalId" class="modal fade show bd-example-modal-xl" tabindex="-1" role="dialog"
        aria-labelledby="profileModalTitle" aria-hidden="true">
        <form >
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">

                <div class="modal-content">
                    <div class="modal-top-cover bg-dark text-center">
                        <figure class="position-absolute end-0 bottom-0 start-0">
                            <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                viewBox="0 0 1920 100.1">
                                <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z" />
                            </svg>
                        </figure>

                        <div class="modal-close">
                            <button type="button" class="btn-close btn-close-light" data-bs-dismiss="modal"
                                aria-label="Close" id="" @click="showMessage = false"></button>
                        </div>
                    </div>

                    <div class="modal-top-cover-icon">
                        <span class="icon icon-lg icon-light icon-circle icon-centered shadow-sm">
                            <i class="bi-receipt fs-2"></i>
                        </span>
                    </div>
                    <div class="modal-body">
                        <slot>

                        </slot>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-white" data-bs-dismiss="modal"
                            @click="showMessage = false">Fermer</button>
                        <slot name="btn">
                            <button type="button" class="btn btn-primary" @click="$emit('handleSubmit')">
                                Enregistrer
                            </button>
                        </slot>
                    </div>
                </div>

            </div>
        </form>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
    name: "WidgetModal",
    
    data() {
        return {
            backdrop: null
        }
    },
    computed: {
        ...mapFields("widget/modal", {
            isLoading: 'isLoading',
            showMessage: 'showMessage',
            message: 'message',
            items: 'items',
            isSuccess: 'isSuccess',

        })
    },
    methods: {
        ...mapActions({
            resetModal: "widget/modal/resetData"
        }),
        closeModal() {
            document.querySelector(".modal-backdrop")?.remove()
            document.querySelector("body").classList.remove("modal-open")
            document.querySelector("#modalId").setAttribute("style", "display:none")
        },
        openModal() {
            document.querySelector("body").classList.add("modal-open")
            this.backdrop = document.createElement("div")
            this.backdrop.setAttribute("class", "modal-backdrop fade show")

            document.querySelector("body").appendChild(this.backdrop)
            document.querySelector("#modalId").setAttribute("style", "display:block")
        }
    },

    watch: {
        showMessage(newVal) {
            if (newVal) {
                this.openModal()
            } else {
                this.closeModal()
            }
        }
    },
    beforeUnmount() {
        this.closeModal()
        this.resetModal()
    }


}
</script>